import { updateListingScore } from '@/utils/product/score';
import { replaceOperation } from '@/utils/product/operations';
import { editTitle } from '@/utils/edit/title';

import { ATTRIBUTE } from '@/constants/attributes';
import { EMPTY } from '@/constants';

export function title({ operation, product, ...rest }) {
  const value = operation.get('value');
  const updates = editTitle({ product, value });

  if (updates.product.hasIn(['score', ATTRIBUTE.TITLE])) {
    const { shop, userFeatures } = rest;
    updates.product = updateListingScore({ product: updates.product, shop, userFeatures });
  }

  return {
    ...rest,
    product: updates.product.set('operations',
      updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
    ),
  };
}
